var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.handleClick }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v(" Asignar Tramo ")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-grabar",
                      staticStyle: {
                        "min-width": "80px",
                        "max-width": "150px"
                      },
                      attrs: { depressed: "" },
                      on: { click: _vm.handleUpdate }
                    },
                    [_vm._v("Guardar")]
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { fluid: "", "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md12: "" } },
                                          [
                                            _c(
                                              "h2",
                                              { staticClass: "h2_title" },
                                              [_vm._v("Asignación de Tramo")]
                                            )
                                          ]
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "",
                                              sm12: "",
                                              "my-5": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm11: "",
                                                  "mb-5": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      xs12: "",
                                                      sm4: "",
                                                      lg3: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        label: "Tramo Baja",
                                                        items: _vm.tramos,
                                                        "item-text":
                                                          "nombre_tramo",
                                                        "item-value":
                                                          "nombre_tramo",
                                                        clearable: "",
                                                        "prepend-icon":
                                                          "home_repair_service"
                                                      },
                                                      model: {
                                                        value: _vm.tramo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.tramo = $$v
                                                        },
                                                        expression: "tramo"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "", sm12: "" } },
                                              [
                                                _c("GridComponent", {
                                                  staticClass:
                                                    "ag-theme-material",
                                                  attrs: {
                                                    "grid-options":
                                                      _vm.gridOptions
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      }),
      _vm.showPopUpReport
        ? _c("PopUpGenerateReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }